// Dependecies
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

// hook
import useLoadData from '../../../hooks/useLoadData';

function useShouldChange() {
  const location = useLocation();
  const { localeStore } = useLoadData();
  const [isChangeLocale, setIsChangeLocale] = useState(false);
  const [, i18n] = useTranslation('global', { useSuspense: false });
  const [pathname, setPathname] = useState('/');

  const validateIfShouldChange = (currentLocale) => {
    const chunkingLocale = location.pathname.split('/');

    if (chunkingLocale[1] === '') {
      setIsChangeLocale(true);
      setPathname(`/${currentLocale}`);
    }
  };

  useEffect(() => {
    function load() {
      i18n.changeLanguage(localeStore.currentLocale).then(() => {
        validateIfShouldChange(localeStore.currentLocale);
      });
    }

    return load();
  }, []);

  return { isChangeLocale, pathname };
}

export default useShouldChange;
